import { render } from "./MasterLayout.vue?vue&type=template&id=58c6fca7&scoped=true"
import script from "./MasterLayout.vue?vue&type=script&lang=js"
export * from "./MasterLayout.vue?vue&type=script&lang=js"

import "./MasterLayout.vue?vue&type=style&index=0&id=58c6fca7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c6fca7"]])

export default __exports__